angular.module("ainapp")
    .controller("bulkEmployeeController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            //            $scope.PageName = "Bulk Delivery Note";
            //            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            //            if ($scope.TokenInfo == null) {
            //                $state.go("login");
            //            } else {
            //                $scope.checkUserPageAccess($scope.PageName);
            //            }

            $scope.Init = function () {

                $scope.VoucherList = [];


            }
            $scope.Init();


            var oFileIn;

            $(function () {
                oFileIn = document.getElementById('my_file_input');
                if (oFileIn.addEventListener) {
                    oFileIn.addEventListener('change', filePicked, false);
                }
            });

            function filePicked(oEvent) {
                var oFile = oEvent.target.files[0];
                var sFilename = oFile.name;
                var reader = new FileReader();

                reader.onload = function (e) {
                    var data = e.target.result;
                    var cfb = XLSX.read(data, {
                        type: 'binary'
                    });
                    console.log(cfb)
                    cfb.SheetNames.forEach(function (sheetName) {
                        var sCSV = XLS.utils.make_csv(cfb.Sheets[sheetName]);
                        var oJS = XLS.utils.sheet_to_json(cfb.Sheets[sheetName]);
                        //.replace(/-/g, "/");
                        angular.forEach(oJS, function (e) {
                            e.Name = e.Name;
                            e.FirstName = e.FirstName;
                            e.SurName = e.SurName;
                            e.FatherName = e.FatherName;
                            e.MotherName = e.MotherName;
                            e.Gender = e.Gender;
                            e.BloodGroup = e.BloodGroup;
                            e.Email = e.Email;
                            e.MobileNo = e.MobileNo;
                            e.TelephoneNo = e.TelephoneNo;
                            e.WhatsappNo = e.WhatsappNo;
                            e.BirthPlace = e.BirthPlace;
                            e.CountryName = e.CountryName;
                            e.DesignationName = e.DesignationName;
                            e.DepartmentName = e.DepartmentName;
                            e.GradeName = e.GradeName;
                            e.ShiftName = e.ShiftName;
                            e.EmployeeId = e.Code;
                            e.JobLocation = e.JobLocation;
                            e.Qualification = e.Qualification;
                            e.Religion = e.Religion;
                            e.Description = e.Description;
                            e.Address = e.Address;
                            e.HomeCountryAddress = e.HomeCountryAddress;
                            e.ReferenceFriendName = e.ReferenceFriendName;
                            e.ReferenceFriendNo = e.ReferenceFriendNo;
                            e.Insurance = e.Insurance;
                            e.MaritalStatus = e.MaritalStatus;
                            e.BirthDateString = e.BirthDate;
                            e.InterviewDateString = e.InterviewDate;
                            e.DesignationDateString = e.DesignationDate;
                            e.StartingDateString = e.StartingDate;
                            e.DateOfJoiningString = e.DateOfJoining;
                            e.ConfirmationDateString = e.ConfirmationDate;
                            e.PassportIssueDateString = e.PassportIssueDate;
                            e.PassportIExpireDateString = e.PassportIExpireDate;
                            e.VisaIssueDateString = e.VisaIssueDate;
                            e.VisaExpireDateString = e.VisaExpireDate;
                            e.LabourCardIssueDateString = e.LabourCardIssueDate;
                            e.LabourCardExpiryDateString = e.LabourCardExpiryDate;
                            e.ContractIssueDateString = e.ContractIssueDate;
                            e.ContractExpiryDateString = e.ContractExpiryDate;
                            e.IDIssueDateString = e.IDIssueDate;
                            e.IDExpiryDateString = e.IDExpiryDate;
                            e.DrivingLicenseIssueDateString = e.DrivingLicenseIssueDate;
                            e.DrivingLicenseExpiryDateString = e.DrivingLicenseExpiryDate;
                            e.MedicalIssueDateString = e.MedicalIssueDate;
                            e.MedicalExpiryDateString = e.MedicalExpiryDate;
                            e.OHCIssueDateString = e.OHCIssueDate;
                            e.OHCExpiryDateString = e.OHCExpiryDate;
                            e.PassportNo = e.PassportNo;
                            e.VisaType = e.VisaType;
                            e.VisaNo = e.VisaNo;
                            e.ContractNo = e.ContractNo;
                            e.LabourCardNo = e.LabourCardNo;
                            e.IDNo = e.IDNo;
                            e.DrivingLicenseNo = e.DrivingLicenseNo;
                            e.MedicalNo = e.MedicalNo;
                            e.OHCNo = e.OHCNo;
                            e.Sponsership = e.Sponsership;
                            e.RoomNo = e.RoomNo;
                            e.Accomodation = e.Accomodation;
                            e.Section = e.Section;
                            e.ModeOfPayment = e.ModeOfPayment;
                            e.BankName = e.BankName;
                            e.BankAccNo = e.BankAccNo;
                            e.IBANNo = e.IBANNo;
                            e.BankBranch = e.BankBranch;
                            e.SwiftCode = e.SwiftCode;
                            e.MolNo = e.MolNo;
                            e.EmployeeType = e.EmployeeType;
                            e.EmergencyContactName = e.EmergencyContactName;
                            e.EmergencyContactNo = e.EmergencyContactNo;
                            e.GuardianName = e.GuardianName;
                            e.GuardianRelation = e.GuardianRelation;
                            e.NetSalary = e.NetSalary;
                            e.AnnualCTC = e.AnnualCTC;
                            e.VacationPeriod = e.VacationPeriod;
                            e.VacationDays = e.VacationDays;
                            e.TicketAdults = e.TicketAdults;
                            e.TicketChildren = e.TicketChildren;
                            e.TicketInfants = e.TicketInfants;
                            e.TicketAmount = e.TicketAmount;
                            e.TicketDestination = e.TicketDestination;
                            e.TicketAirClass = e.TicketAirClass;
                            e.LOPDays = e.LOPDays;
                            e.RemainingVacationDays = e.RemainingVacationDays;
                            e.RemainingVacationSalary = e.RemainingVacationSalary;
                            e.RemainingTickets = e.RemainingTickets;

                        });

                        $scope.VoucherList = oJS;
                        $scope.$apply();
                    });
                };

                reader.readAsBinaryString(oFile);
            }



            $scope.uploadProducts = function () {

                var temp = 0;
                angular.forEach($scope.VoucherList, function (e) {

                    if (e.Name == "" || e.MobileNo == "" || e.EmployeeId == "" || e.Name == undefined || e.MobileNo == undefined || e.EmployeeId == undefined || e.Name == null || e.MobileNo == null || e.EmployeeId == null) {
                        temp = 1;
                    }

                    e.BirthDate = null;
                    e.InterviewDate = null;
                    e.DesignationDate = null;
                    e.StartingDate = null;
                    e.DateOfJoining = null;
                    e.ConfirmationDate = null;
                    e.PassportIssueDate = null;
                    e.PassportIExpireDate = null;
                    e.VisaIssueDate = null;
                    e.VisaExpireDate = null;
                    e.LabourCardIssueDate = null;
                    e.LabourCardExpiryDate = null;
                    e.ContractIssueDate = null;
                    e.ContractExpiryDate = null;
                    e.IDIssueDate = null;
                    e.IDExpiryDate = null;
                    e.DrivingLicenseIssueDate = null;
                    e.DrivingLicenseExpiryDate = null;
                    e.MedicalIssueDate = null;
                    e.MedicalExpiryDate = null;
                    e.OHCIssueDate = null;
                    e.OHCExpiryDate = null;

                })

                if (temp == 1) {
                    toastr.warning("Invalid Format. Name, Mobile No, Code Required. ");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.AddBulkEmployee($scope.VoucherList).then(function (response) {
                        if (response.data == 1) {
                            toastr.success("Success");
                            $scope.Init();
                        } else {
                            toastr.warning("Failed ");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }


            }



        }])
